/**
 * Constant representing all plan-gated feature codes.
 * Values exactly match the backend FeatureCode enum.
 */
export const FeatureCode = {
  // Numeric limits
  MAX_PROJECTS: 'MAX_PROJECTS',
  MAX_OPEN_POSITIONS: 'MAX_OPEN_POSITIONS',
  MAX_RECRUITERS: 'MAX_RECRUITERS',
  MAX_ACTIVE_USERS: 'MAX_ACTIVE_USERS',
  MAX_CANDIDATE_POOL: 'MAX_CANDIDATE_POOL',

  // Boolean flags
  COPY_PAST_JD: 'COPY_PAST_JD',
  REQUISITION_APPROVAL: 'REQUISITION_APPROVAL',
  REQUISITION_ASSIGNMENT: 'REQUISITION_ASSIGNMENT',
  POST_TO_LINKEDIN: 'POST_TO_LINKEDIN',
  CAREER_EMAIL_FETCH: 'CAREER_EMAIL_FETCH',
  SEND_CANDIDATE_FORM: 'SEND_CANDIDATE_FORM',
  AI_CANDIDATE_MATCHING: 'AI_CANDIDATE_MATCHING',
  AI_INTERVIEW_AGENT: 'AI_INTERVIEW_AGENT',
  CUSTOM_LOGO: 'CUSTOM_LOGO',

  // Enum values
  INTERVIEW_PANEL_MODE: 'INTERVIEW_PANEL_MODE',
  CANDIDATE_MATCHING: 'CANDIDATE_MATCHING',
  MEETING_PLATFORMS: 'MEETING_PLATFORMS',
  OFFER_LETTER_MODE: 'OFFER_LETTER_MODE',
};

export const FEATURE_LABELS = {
  MAX_PROJECTS: 'Maximum Projects',
  MAX_OPEN_POSITIONS: 'Maximum Open Positions',
  MAX_RECRUITERS: 'Maximum Recruiters',
  MAX_ACTIVE_USERS: 'Maximum Active Users',
  MAX_CANDIDATE_POOL: 'Maximum Candidate Pool',
  COPY_PAST_JD: 'Copy from Past JD',
  REQUISITION_APPROVAL: 'Requisition Approval',
  REQUISITION_ASSIGNMENT: 'Requisition Assignment',
  POST_TO_LINKEDIN: 'Post to LinkedIn',
  CAREER_EMAIL_FETCH: 'Career Email Fetch',
  SEND_CANDIDATE_FORM: 'Send Candidate Form',
  AI_CANDIDATE_MATCHING: 'AI Candidate Matching',
  AI_INTERVIEW_AGENT: 'AI Interview Agent',
  CUSTOM_LOGO: 'Custom Logo',
  INTERVIEW_PANEL_MODE: 'Interview Panel Mode',
  CANDIDATE_MATCHING: 'Candidate Matching',
  MEETING_PLATFORMS: 'Meeting Platforms',
  OFFER_LETTER_MODE: 'Offer Letter Mode',
};
